import React, { useCallback, useState } from 'react';
import { CheckInSystem } from './CheckInSystem';
import { EnterPassword } from './EnterPassword';
import { CheckInAuthenticator } from './CheckInAuthenticator';

interface IProps {
  initEmail?: string
}

export type TAuthTabs =
  | 'CheckInSystem'
  | 'EnterPassword'
  | 'CheckInAuthenticator';

export const AuthTabs: React.FC<IProps> = ({ initEmail }) => {
  const [tab, setTab] = useState<TAuthTabs>('CheckInSystem');
  const [tabProps, setTabProps] = useState<any>({});

  const authTabSwitcher = useCallback(() => {
    switch (tab) {
      case 'CheckInSystem':
        return <CheckInSystem initEmail={initEmail} changeAuthTab={changeAuthTab} {...tabProps} />;
      case 'EnterPassword':
        return <EnterPassword changeAuthTab={changeAuthTab} {...tabProps} />;
      case 'CheckInAuthenticator':
        return <CheckInAuthenticator changeAuthTab={changeAuthTab} {...tabProps} />;
      default:
        return <></>;
    }
  }, [tab]);

  const changeAuthTab = useCallback((newTab: TAuthTabs, props: any = {}) => {
    setTab(newTab);
    setTabProps(props);
  }, []);

  return authTabSwitcher();
};
